import hasPermission from "./hasPermission.directive";

const hasPermissionModule = angular
  .module("app.directives.hasPermission", [])
  .directive("hasPermission", hasPermission);

export default hasPermissionModule;



// WEBPACK FOOTER //
// ./src/directives/hasPermission/hasPermission.module.js